export enum InputRatingAction {
  Save = 'Save',
  Previous = 'Previous',
  Next = 'Next',
  Print = 'Print',
  Lock = 'Lock',
  Unlock = 'Unlock',
}
